import React, { useEffect, useState, useRef } from 'react';
import { Tag, ShoppingCart, Heart, Clock, Search, Percent, Sparkles, Check, Bookmark, Image, Star, Users, Gift, Crown } from 'lucide-react';
const showcaseItems = [{
  id: 'wishlist',
  icon: <Heart className="h-8 w-8" data-id="element-263" />,
  title: 'Wishlist System',
  description: 'Let customers save favorites for later. 31% return to buy within 30 days. Perfect for gift registries.',
  stat: 'Free',
  type: 'free',
  gradient: 'from-pink-500 to-red-500',
  image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Works for guests and logged-in users', 'Multiple icon options (Heart, Bookmark, Star, Plus)', 'Thumbnail overlay button', 'AJAX add/remove without reload']
}, {
  id: 'cart',
  icon: <ShoppingCart className="h-8 w-8" data-id="element-264" />,
  title: 'Side Cart Drawer',
  description: 'Slide-out cart that opens when items are added. Never lose a sale to distraction again.',
  stat: 'Free',
  type: 'free',
  gradient: 'from-green-500 to-emerald-500',
  image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Opens automatically on add-to-cart', 'Live quantity updates', 'Menu integration with custom triggers', 'Respects all WooCommerce calculations']
}, {
  id: 'badges',
  icon: <Tag className="h-8 w-8" data-id="element-265" />,
  title: 'Product Badge System',
  description: 'Create badges that grab attention and drive action. Auto-assign by rules or place manually.',
  stat: 'Free: 2 badges',
  type: 'limited',
  gradient: 'from-purple-500 to-pink-500',
  image: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Custom text, colors, and positioning', 'Auto-badge New, Sale, Featured, Low Stock', 'Corner placement with animations', 'Bulk assignment tools']
}, {
  id: 'discount',
  icon: <Percent className="h-8 w-8" data-id="element-266" />,
  title: 'Multi-Item Discounts',
  description: 'Reward bulk purchases with tiered pricing. "Buy 3 get 10% off, Buy 5 get 20% off"—automatically.',
  stat: 'Free: 2 rules',
  type: 'limited',
  gradient: 'from-blue-500 to-cyan-500',
  image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Unlimited discount tiers', 'Apply to products or categories', 'Dynamic progress bar in cart', 'Auto-applies best discount']
}, {
  id: 'gallery',
  icon: <Image className="h-8 w-8" data-id="element-267" />,
  title: 'Product Gallery & Video',
  description: 'Turn feature images into sliders. Add product videos to listings and galleries. Video boosts conversions 80%.',
  stat: 'Gallery free',
  type: 'limited',
  gradient: 'from-violet-500 to-purple-500',
  image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Feature image slider on listings', 'Product video support', 'Video on listing or as first slide', 'Display in main product gallery']
}, {
  id: 'sales',
  icon: <Sparkles className="h-8 w-8" data-id="element-268" />,
  title: 'Store-Wide Flash Sales',
  description: 'Run campaigns with countdown timers and sale banners. Create FOMO that drives instant purchases.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-red-500 to-orange-500',
  image: 'https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Countdown timers with 6 color themes', 'Sticky sale banners (customizable)', 'Timezone-aware scheduling', 'Exclude products/categories']
}, {
  id: 'search',
  icon: <Search className="h-8 w-8" data-id="element-269" />,
  title: 'AJAX Instant Search',
  description: 'Real-time search with instant results. 6 beautiful templates, split preview, and add-to-cart from results.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-indigo-500 to-purple-500',
  image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['6 field templates (Classic, Rounded, Pill, Minimal, Elevated, Outlined)', '4 results layouts (Simple, Split Preview, Compact, Grid)', 'Search by title, content, and SKU', 'Interactive hover preview panel']
}, {
  id: 'viewed',
  icon: <Clock className="h-8 w-8" data-id="element-270" />,
  title: 'Recently Viewed Products',
  description: 'Track browsing history automatically. Show customers what they viewed—keeps them engaged 24% longer.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-orange-500 to-yellow-500',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Tracks up to 20 products automatically', 'Cookie-based (GDPR-friendly)', 'Auto-generated dedicated page', 'Shortcode for custom placement']
}, {
  id: 'save-later',
  icon: <Bookmark className="h-8 w-8" data-id="element-271" />,
  title: 'Save for Later',
  description: 'Amazon-style "Save for Later" on cart page. Move items aside without losing them—reduces abandonment.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-teal-500 to-green-500',
  image: 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Separate "Saved for Later" section on cart', 'Move items between cart and saved', 'Quick add back to cart', 'Persistent across sessions']
}, {
  id: 'reviews',
  icon: <Star className="h-8 w-8" data-id="element-272" />,
  title: 'Advanced Product Reviews',
  description: 'Collect reviews that convert. Scheduled emails, photo & video reviews, beautiful display layouts.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-yellow-500 to-orange-500',
  image: 'https://images.unsplash.com/photo-1556740758-90de374c12ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Scheduled email campaigns', 'Photo & video review uploads', 'Multiple display layouts (slider, grid)', 'Review moderation dashboard']
}, {
  id: 'wholesale',
  icon: <Users className="h-8 w-8" data-id="element-273" />,
  title: 'Wholesale Pricing',
  description: 'Unlock B2B revenue. Custom wholesale user role with separate pricing. Perfect for bulk buyers and distributors.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-blue-600 to-indigo-600',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Wholesale user role registration', 'Product-level wholesale prices', 'Hide retail prices for wholesale users', 'Works alongside sale/regular prices']
}, {
  id: 'giftcards',
  icon: <Gift className="h-8 w-8" data-id="element-274" />,
  title: 'Digital Gift Cards',
  description: 'Sell gift cards that bring new customers and guaranteed future revenue. Perfect for holidays and corporate gifting.',
  stat: 'Premium',
  type: 'premium',
  gradient: 'from-rose-500 to-pink-500',
  image: 'https://images.unsplash.com/photo-1549465220-1a8b9238cd48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  highlights: ['Custom denominations', 'Email delivery system', 'Unique redemption codes', 'Balance tracking and management']
}];
export function Showcase() {
  const showcaseRef = useRef(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (showcaseRef.current) {
      observer.observe(showcaseRef.current);
    }
    return () => {
      if (showcaseRef.current) {
        observer.disconnect();
      }
    };
  }, []);
  const activeItem = showcaseItems[activeIndex];
  const scrollToButton = (index: number) => {
    setActiveIndex(index);
    if (scrollContainerRef.current) {
      const button = scrollContainerRef.current.children[index] as HTMLElement;
      if (button) {
        const containerRect = scrollContainerRef.current.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        const scrollLeft = scrollContainerRef.current.scrollLeft;
        const targetScroll = scrollLeft + buttonRect.left - containerRect.left - containerRect.width / 2 + buttonRect.width / 2;
        scrollContainerRef.current.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }
    }
  };
  const getBadgeStyles = (type: string) => {
    switch (type) {
      case 'free':
        return 'bg-green-100 text-green-700';
      case 'limited':
        return 'bg-blue-100 text-blue-700';
      case 'premium':
        return 'bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-700';
      default:
        return 'bg-purple-100 text-purple-700';
    }
  };
  return <section id="showcase" className="py-20 md:py-32 bg-gradient-to-b from-gray-50 to-white" ref={showcaseRef} data-id="element-275">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-276">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-277">
          <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 rounded-full px-4 py-2 mb-6" data-id="element-278">
            <Sparkles className="h-4 w-4" data-id="element-279" />
            <span className="text-sm font-medium" data-id="element-280">
              12 tools, one powerful plugin
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-281">
            See How Each Tool{' '}
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent" data-id="element-282">
              Boosts Your Revenue
            </span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-283">
            Click any tool below to explore its features and see how it
            transforms your store.
          </p>
        </div>

        {/* Horizontal scrollable navigation */}
        <div className="relative mb-12" data-id="element-284">
          <div ref={scrollContainerRef} className="flex gap-3 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-285">
            {showcaseItems.map((item, index) => <button key={item.id} onClick={() => scrollToButton(index)} className={`flex-shrink-0 snap-start group relative px-6 py-4 rounded-xl transition-all duration-300 ${activeIndex === index ? 'bg-white shadow-lg border-2 border-purple-200' : 'bg-white/60 border-2 border-transparent hover:bg-white hover:shadow-md'}`} data-id="element-286">
                <div className="flex items-center gap-3" data-id="element-287">
                  <div className={`p-2 rounded-lg bg-gradient-to-br ${item.gradient} transition-transform ${activeIndex === index ? 'scale-110' : 'scale-100'}`} data-id="element-288">
                    <div className="text-white" data-id="element-289">{item.icon}</div>
                  </div>
                  <div className="text-left" data-id="element-290">
                    <h3 className="font-bold text-gray-900 text-sm whitespace-nowrap" data-id="element-291">
                      {item.title}
                    </h3>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full inline-flex items-center gap-1 mt-1 ${getBadgeStyles(item.type)}`} data-id="element-292">
                      {item.type === 'premium' && <Crown className="h-2.5 w-2.5" data-id="element-293" />}
                      {item.stat}
                    </span>
                  </div>
                </div>

                {/* Active indicator */}
                {activeIndex === index && <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-gradient-to-r from-purple-600 to-blue-600 rounded-t-full" data-id="element-294" />}
              </button>)}
          </div>

          {/* Gradient fade edges */}
          <div className="absolute top-0 left-0 bottom-4 w-12 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none" data-id="element-295" />
          <div className="absolute top-0 right-0 bottom-4 w-12 bg-gradient-to-l from-white to-transparent pointer-events-none" data-id="element-296" />
        </div>

        {/* Content display */}
        <div className={`transition-all duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-297">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-298">
            <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-299">
              {/* Left: Image */}
              <div className="order-2 lg:order-1" data-id="element-300">
                <div className="bg-gray-800/50 rounded-2xl overflow-hidden" data-id="element-301">
                  <div className="bg-gray-700/50 px-4 py-3 flex items-center gap-2 border-b border-gray-600" data-id="element-302">
                    <div className="flex gap-1.5" data-id="element-303">
                      <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-304"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-305"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-306"></div>
                    </div>
                  </div>
                  <img key={activeItem.id} src={activeItem.image} alt={activeItem.title} className="w-full h-64 md:h-80 object-cover transition-opacity duration-300" data-id="element-307" />
                </div>
              </div>

              {/* Right: Details */}
              <div className="order-1 lg:order-2 space-y-6" data-id="element-308">
                <div className="flex items-start gap-4" data-id="element-309">
                  <div className={`p-3 rounded-xl bg-gradient-to-br ${activeItem.gradient} flex-shrink-0`} data-id="element-310">
                    <div className="text-white" data-id="element-311">{activeItem.icon}</div>
                  </div>
                  <div className="flex-1" data-id="element-312">
                    <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-313">
                      {activeItem.title}
                    </h3>
                    <p className="text-gray-400 mb-3" data-id="element-314">
                      {activeItem.description}
                    </p>
                    <span className={`text-xs font-medium px-3 py-1 rounded-full inline-flex items-center gap-1 ${getBadgeStyles(activeItem.type)}`} data-id="element-315">
                      {activeItem.type === 'premium' && <Crown className="h-3 w-3" data-id="element-316" />}
                      {activeItem.stat}
                    </span>
                  </div>
                </div>

                <ul className="space-y-3" data-id="element-317">
                  {activeItem.highlights.map((highlight, i) => <li key={i} className="flex items-start gap-3 transition-all duration-300" style={{
                  transitionDelay: `${i * 50}ms`
                }} data-id="element-318">
                      <Check className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-319" />
                      <span className="text-gray-300" data-id="element-320">{highlight}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}